module.exports = __webpack_public_path__ + "assets/img/img-benefit-01.e9291153.jpg";